import { useState } from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';
import api from '../../../../services/api';

/**
 * Confirmation de l'effacement des corrections rédigées d'une thématique
 * (migration 148, suppression douce côté serveur : la ligne reste en base pour
 * les décomptes, elle disparaît de tout ce que l'utilisateur voit).
 * L'historique de quiz n'est pas touché, et aucun crédit n'est rendu : les deux
 * points sont dits ici, avant la case à cocher.
 */
export default function QrcClearModal({ scopeId, count, onClose, onCleared }) {
    const [confirmed, setConfirmed] = useState(false);
    const [clearing, setClearing] = useState(false);
    const s = count > 1 ? 's' : '';

    return (
        <div className="checkout-modal-overlay" onClick={onClose}>
            <div className="checkout-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '440px' }}>
                <div className="checkout-modal__header" style={{ background: 'var(--danger)', color: '#fff' }}>
                    <span className="checkout-modal__title"><AlertTriangle size={18} /> Effacer mes corrections</span>
                </div>
                <div className="checkout-modal__body" style={{ padding: '20px' }}>
                    <p style={{ marginBottom: '12px', fontWeight: 600 }}>
                        Tu es sur le point d’effacer {count} correction{s} rédigée{s} sur cette thématique.
                    </p>
                    <ul style={{ fontSize: '0.88em', color: 'var(--text-muted)', marginBottom: '16px', paddingLeft: '20px' }}>
                        <li>Les verdicts ne seront plus consultables.</li>
                        <li>Les questions redeviennent « à faire », tu peux les rédiger de nouveau.</li>
                        <li>Ton historique de quiz n’est pas touché.</li>
                    </ul>
                    <p style={{ fontSize: '0.85em', color: 'var(--danger)', fontWeight: 600, marginBottom: '16px' }}>
                        Les corrections déjà consommées ne sont pas rendues à ton solde, et cette action est irréversible.
                    </p>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '16px', fontSize: '0.88em' }}>
                        <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} />
                        <span>Je comprends et je veux repartir de zéro</span>
                    </label>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                        <button className="btn btn-sm btn-ghost" onClick={onClose}>Annuler</button>
                        <button
                            className="btn btn-sm"
                            style={{ background: 'var(--danger)', color: '#fff' }}
                            disabled={!confirmed || clearing}
                            onClick={async () => {
                                setClearing(true);
                                try {
                                    await api.post('/qcm/qrc-clear-history.php', { scope_id: scopeId });
                                    onClose();
                                    onCleared?.();
                                } catch (err) {
                                    alert(err.response?.data?.message || 'Erreur');
                                }
                                setClearing(false);
                            }}
                        >
                            <Trash2 size={14} /> {clearing ? 'Effacement…' : 'Effacer'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
